export default __webpack_public_path__ + "static/media/image3pro5.396be987.jpeg";